import {make} from 'vuex-pathify'
import Vue from 'vue'

const initialState = {
  name: null,
  projectType: null,
  notesByDepartment: {},
  isActiveDepartment: false,
  stopWork: false,
  active: false,
  createdAt: null,
  createdBy: null,
  updatedAt: null,
  updatedBy: null
}

const state = Vue.util.extend({}, JSON.parse(JSON.stringify(initialState)))

const getters = make.getters(state)
const mutations = make.mutations(state)

mutations.all = (state, payload) => {
  state.name = payload.name
  state.projectType = payload.projectType
  state.notesByDepartment = payload.notesByDepartment || {}
  state.stopWork = payload.stopWork
  state.active = payload.active
  state.createdAt = payload.createdAt
  state.createdBy = payload.createdBy
  state.updatedAt = payload.updatedAt
  state.updatedBy = payload.updatedBy

  const projectDetails = {
    name: payload.name,
    projectType: payload.projectType,
    notesByDepartment: payload.notesByDepartment || {},
    stopWork: payload.stopWork,
    active: payload.active,
    createdAt: payload.createdAt,
    createdBy: payload.createdBy,
    updatedAt: payload.updatedAt,
    updatedBy: payload.updatedBy
  }

  Vue.prototype.$eventHub.$emit('projectDetailsLoaded', projectDetails)
}

mutations.reset = (state) => {
  for (let f in state) {
    Vue.set(state, f, initialState[f])
  }
}

mutations.updateProjectNotes = (state, payload) => {
  state.notesByDepartment[payload.departmentId] = payload.notes
}

getters.isActiveDepartment = (state) => {
  return state.isActiveDepartment
}

getters.all = (state) => {
  return state
}

export default {
  namespaced: true,
  state,
  getters,
  mutations
}